interface IpInfo {
  ip: string;
  currency: string;
  phoneCode: string;
  phoneRegion: string;
  region: REGION;
  country: string;
  signupType: string; // 游客模式下注册方式
}

// ip => 区号 => 客服 => 货币 => 国家
const IpInfoList: IpInfo[] = [
  // 中国ip
  {
    ip: "China",
    currency: "CNY",
    phoneRegion: "CN",
    phoneCode: "86",
    country: "CN",
    region: "US",
    signupType: "wechat",
  },
  // 印尼
  {
    ip: "Indonesia",
    currency: "IDR",
    phoneRegion: "ID",
    phoneCode: "62",
    country: "ID",
    region: "ID",
    signupType: "sms",
  },
  // 泰国
  {
    ip: "Thailand",
    currency: "THB",
    phoneRegion: "TH",
    phoneCode: "66",
    country: "TH",
    region: "TH",
    signupType: "sms",
  },
  // 马来
  {
    ip: "Malaysia",
    currency: "MYR",
    phoneCode: "60",
    phoneRegion: "MY",
    country: "MY",
    region: "MY",
    signupType: "sms",
  },
  // 菲律宾
  {
    ip: "Philippines",
    currency: "PHP",
    phoneCode: "63",
    phoneRegion: "PH",
    country: "PH",
    region: "PH",
    signupType: "sms",
  },
  // 越南
  {
    ip: "Vietnam",
    currency: "VND",
    phoneCode: "84",
    phoneRegion: "VN",
    country: "VN",
    region: "VN",
    signupType: "sms",
  },
  {
    ip: "Singapore",
    currency: "SGD",
    phoneCode: "65",
    phoneRegion: "SG",
    country: "SG",
    region: "SG",
    signupType: "sms",
  },
  // 美国ip
  {
    ip: "United States",
    currency: "USD",
    phoneCode: "1",
    phoneRegion: "US",
    country: "US",
    region: "US",
    signupType: "email",
  },
  {
    ip: "United Kingdom",
    currency: "GBP",
    phoneCode: "44",
    phoneRegion: "GB",
    country: "GB",
    region: "GB",
    signupType: "email",
  },
  {
    ip: "Mexico",
    currency: "MXN",
    phoneCode: "52",
    phoneRegion: "MX",
    country: "MX",
    region: "MX",
    signupType: "email",
  },
  {
    ip: "Germany",
    currency: "EUR",
    phoneCode: "49",
    phoneRegion: "DE",
    country: "DE",
    region: "DE",
    signupType: "email",
  },
  {
    ip: "France",
    currency: "EUR",
    phoneCode: "33",
    phoneRegion: "FR",
    country: "FR",
    region: "FR",
    signupType: "email",
  },
  {
    ip: "Italy",
    currency: "EUR",
    phoneCode: "39",
    phoneRegion: "IT",
    country: "IT",
    region: "IT",
    signupType: "email",
  },
  {
    ip: "Spain",
    currency: "EUR",
    phoneCode: "34",
    phoneRegion: "ES",
    country: "ES",
    region: "ES",
    signupType: "email",
  },
  {
    ip: "Japan",
    currency: "JPY",
    phoneCode: "81",
    phoneRegion: "JP",
    country: "JP",
    region: "JP",
    signupType: "email",
  },
  {
    ip: "Brazil",
    currency: "BRL",
    phoneCode: "55",
    phoneRegion: "BR",
    country: "BR",
    region: "BR",
    signupType: "email",
  },
  {
    ip: "Others",
    currency: "USD",
    phoneCode: "1",
    phoneRegion: "US",
    country: "US",
    region: "US",
    signupType: "email",
  },
];

const findIpInfo = (ip: string): IpInfo | undefined => {
  return IpInfoList.find((item) => item.ip === ip);
};

let defaultIpInfo: IpInfo = (findIpInfo(window?.KALO_DATA?.reqCountry) || findIpInfo("Others")) as IpInfo;

export default defaultIpInfo;
